import { graphql } from '../graphql';
import { useRequest } from './client/useRequest';
export const SEND_MESSAGE = graphql(`
  mutation SendMessage($id: String!, $message: String!, $timestamp: String!) {
    sendMessage(input: { id: $id, message: $message, timestamp: $timestamp })
  }
`);
export const useSendMessageRequest = () => {
    return useRequest(SEND_MESSAGE, {});
};
